// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

import Cookies from "js-cookie"
window.Cookies = Cookies
window.$ = $

Rails.start()
ActiveStorage.start()

function toggleTheme() {
    if (document.body.classList.contains('light')) {
        Cookies.set('theme', 'dark');
        document.body.classList.remove('light');
        document.body.classList.add('dark');
    } else {
        Cookies.set('theme', 'light');
        document.body.classList.remove('dark');
        document.body.classList.add('light');
    }
}

function activateThemeSwitcher() {
    document.getElementById('theme-toggle').addEventListener('click', function(event) {
        toggleTheme();
        event.preventDefault();
    }, false);
}

window.addEventListener('load', activateThemeSwitcher);

import "bootstrap"
import "../src/formtastic_bootstrapping"
import "../src/ppds.date"
import "../src/jquery.beatsclock"
import "../src/main"
